import {useState, useEffect} from 'react';
import { fetch as authFetch } from '../Helpers/auth';


const useDeleteItem = ({url, cb=()=>null}) => {
  const [isDeleting, setIsDeleting] = useState(false)
  const [isDeleted, setIsDeleted] = useState(false)
  const [error, setError] = useState(null)
  const [data, deleteData] = useState(undefined)
  const [answer, setAnswer] = useState(undefined)
  useEffect(() => {
    if (data) {
      setIsDeleting(true);    
      setIsDeleted(false);    
      authFetch(url+data, { method: "DELETE" })
        .then(res => res.json())
        .then(res => {
          setIsDeleting(false);
          setIsDeleted(true);
          setAnswer(res);
          cb(res);
      }).catch(setError)
    }
  }, [data])
  return {
    isDeleting,
    isDeleted,
    deleteData,
    answer,
    error,
    data,
  }
}

export default useDeleteItem
